class Controller {
  constructor(Events) {
    "ngInject";

    this.Events = Events;
  }

  $onInit() {
    this.edit = (index) => {
      this.items[index].comment.isDisabled = false;
    };

    this.add = () => {
      this.items.unshift({});
    };

    this.save = (item, index) => {
      if (item.comment) {
        item.index = index;
        this.Events.emit(this.eventName, item);
      }
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/notes/notes.controller.js